/* ==========================================================================
   Wild Touch Engraving - the Engraving Burin

   The signature element. A gold light point follows the pointer and leaves a
   fading scribe trail behind it, as if the cursor were cutting the page.
   Full tier only. Never replaces the native cursor on touch, never touches
   focus rings.
   ========================================================================== */

(function () {
  'use strict';

  if (document.documentElement.getAttribute('data-motion-tier') !== 'full') return;
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var host = document.querySelector('[data-burin]');
  if (!host) return;

  var point = host.querySelector('.burin__point');
  var canvas = host.querySelector('canvas');
  var ctx = canvas.getContext('2d');
  var dpr = Math.min(window.devicePixelRatio || 1, 2);

  var target = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
  var pos = { x: target.x, y: target.y };
  var trail = [];
  var sparks = [];
  var idle = 0;
  var running = false;

  function size() {
    canvas.width = window.innerWidth * dpr;
    canvas.height = window.innerHeight * dpr;
    canvas.style.width = window.innerWidth + 'px';
    canvas.style.height = window.innerHeight + 'px';
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }

  size();
  window.addEventListener('resize', size, { passive: true });

  document.addEventListener(
    'pointermove',
    function (e) {
      if (e.pointerType !== 'mouse') return;
      target.x = e.clientX;
      target.y = e.clientY;
      idle = 0;
      host.classList.toggle(
        'is-over-interactive',
        !!(e.target.closest && e.target.closest('a, button, [role="button"], input, select, textarea, summary'))
      );
      start();
    },
    { passive: true }
  );

  document.addEventListener('pointerdown', function (e) {
    if (e.pointerType !== 'mouse') return;
    for (var i = 0; i < 4; i++) {
      var a = Math.random() * Math.PI * 2;
      var v = 1.6 + Math.random() * 2.6;
      sparks.push({ x: e.clientX, y: e.clientY, vx: Math.cos(a) * v, vy: Math.sin(a) * v, life: 1 });
    }
    start();
  });

  function start() {
    if (running || document.hidden) return;
    running = true;
    requestAnimationFrame(frame);
  }

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) start();
  });

  function frame() {
    /* the lag is the point: the trail is a cut, not a shadow */
    pos.x += (target.x - pos.x) * 0.18;
    pos.y += (target.y - pos.y) * 0.18;

    point.style.transform = 'translate3d(' + pos.x + 'px,' + pos.y + 'px,0)';

    trail.push({ x: pos.x, y: pos.y, life: 1 });
    if (trail.length > 26) trail.shift();

    ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);

    ctx.lineCap = 'round';
    for (var i = 1; i < trail.length; i++) {
      var a = trail[i - 1];
      var b = trail[i];
      var t = i / trail.length;
      ctx.strokeStyle = 'rgba(232, 199, 122,' + t * 0.5 * b.life + ')';
      ctx.lineWidth = t * 2.2;
      ctx.beginPath();
      ctx.moveTo(a.x, a.y);
      ctx.lineTo(b.x, b.y);
      ctx.stroke();
    }

    trail.forEach(function (p) {
      p.life *= 0.94;
    });

    for (var s = sparks.length - 1; s >= 0; s--) {
      var sp = sparks[s];
      sp.x += sp.vx;
      sp.y += sp.vy;
      sp.vy += 0.12;
      sp.life -= 0.03;
      if (sp.life <= 0) {
        sparks.splice(s, 1);
        continue;
      }
      ctx.fillStyle = 'rgba(202, 153, 59,' + sp.life + ')';
      ctx.fillRect(sp.x - 1.5, sp.y - 1.5, 3, 3);
    }

    idle++;
    var settled = Math.abs(target.x - pos.x) < 0.4 && Math.abs(target.y - pos.y) < 0.4;
    if (settled && !sparks.length && idle > 60) {
      running = false;
      ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);
      trail.length = 0;
      return;
    }
    requestAnimationFrame(frame);
  }

  start();
})();
